import PropTypes from 'prop-types';
import cx from 'classnames';
import { FITMENT_VARIANTS } from '../../../../../constants/commonConstants';

const FitmentContent = ({
  icon: Icon,
  iconSize,
  className,
  fill,
  buttonTitle,
  variant
}) => (
  <div className={`d-flex flex-row p-0 text-start`}>
    <div
      className={cx(
        {
          'my-2': variant === FITMENT_VARIANTS.large
        },
        'd-flex flex-row btn__icon-left u-color--ExtraDarkGray text-sans-serif text-transform-none',
        className
      )}
      data-testid="FitmentContent-container"
    >
      {Icon ? (
        <div className="h-100">
          <Icon
            className="me-2"
            height={iconSize}
            width={iconSize}
            style={{ fill: fill }}
          />
        </div>
      ) : null}
      {buttonTitle}
    </div>
  </div>
);

FitmentContent.propTypes = {
  variant: PropTypes.shape({
    name: PropTypes.string,
    iconSize: PropTypes.number,
    classes: PropTypes.string,
    showPopup: PropTypes.bool
  }),
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
  buttonTitle: PropTypes.element
};

export default FitmentContent;
